import { ButtonTertiary } from "@nova/component-btn"
import { useSpidertracksIntegration } from "features/map/layers/aircraft-tracking/useSpidertracksIntegration"
import FleetManager from "./fleet-manager.svg"
import * as Icons from "@nova/component-icons"
import Link from "next/link"

export function SpidertracksIntegrationUI({ workspaceId }: { workspaceId: string }) {
    const { email: existingEmail } = useSpidertracksIntegration(workspaceId)

    return (
        <div className="flex items-center gap-6 w-full py-6 border-b border-b-gray-700">
            <div className="w-[120px] flex justify-center pt-1 shrink-0">
                <FleetManager />
            </div>
            <small className="text-gray-200 grow shrink min-w-0 break-words">
                Track your Fleet Manager aircraft assets directly on your incident map alongside
                live air traffic.
            </small>
            {!!existingEmail && (
                <ButtonTertiary
                    disabled
                    title="Already Connected"
                    className="shrink-0"
                    LeftIcon={Icons.Checkmark}
                />
            )}
            {!existingEmail && (
                <Link href="mailto:info@mapnova.com" className="shrink-0">
                    <ButtonTertiary title="Talk to sales" RightIcon={Icons.Mail} />
                </Link>
            )}
        </div>
    )
}
